// 产品管理上传文件
import service from "@/utils/axios";

// 下载模板
export const exportExcle = (params) => service.post('/meta/device/detail/exportDeviceInfo', params, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    responseType: "blob"
});

// /send/batch/param/do/send 下发批量任务
// /send/batch/param/import/device/excel 数据sn导入

// 下发批量任务
export const postDoSend = (params) => service.post('/meta/send/batch/param/do/send', params , {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 数据sn导入
export const postDeviceExcel = (params) => service.post('/meta/send/batch/param/import/device/excel', params , {
    headers: { 'Content-Type': "multipart/form-data; boundary=something" }
});

// /send/batch/param/stop/task 任务终止
export const putStopTask = (params) => service.put(`/meta/send/batch/param/stop/task?taskId=${params.id}`, params , {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// /send/batch/param/list/product 获取产品型号下拉
// /send/batch/param/list/task/detail/page 获取批量下发参数任务详情
// /send/batch/param/list/task/page 获取任务列表
// /send/batch/param/template/download 模板下载

// 获取产品型号下拉
export const getProductList = (params) => service.get('/meta/send/batch/param/list/product', { params });

// 获取批量下发参数任务详情
export const getTaskDetailPage = (params) => service.get('/meta/send/batch/param/list/task/detail/page', { params });

// 获取任务列表
export const getTaskPage = (params) => service.get('/meta/send/batch/param/list/task/page', { params });

// 模板下载
export const getTemplateDownload = (params) => service.get('/meta/send/batch/param/template/download', { 
    params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    responseType: "blob" 
});
